import type { SVGProps } from "react";

export function IconDarkPurpleLightbulb(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 34 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.5 30.25H11.5M17 26.125V16.1562M17 16.1562H13.5625M17 16.1562H20.4375M28.6875 13.75C28.6875 17.6264 26.8003 21.0621 23.8946 23.1883C23.0756 23.7876 22.5 24.6988 22.5 25.7137V26.125H11.5V25.7137C11.5 24.6988 10.9244 23.7876 10.1054 23.1883C7.19969 21.0621 5.3125 17.6264 5.3125 13.75C5.3125 7.29517 10.5452 2.0625 17 2.0625C23.4548 2.0625 28.6875 7.29517 28.6875 13.75Z"
        stroke="#3E2247"
        strokeWidth="2.0625"
        strokeLinecap="square"
      />
    </svg>
  );
}
